export default "__VITE_ASSET__ea961f8a__"